import React, { useState } from 'react';

const TerminateDialog = ({ isOpen, onClose, onConfirm }) => {
    const [comment, setComment] = useState('');
    const [loading, setLoading] = useState(false)
    const handleSubmit = () => {
        setLoading(true)
        onConfirm(comment);
        onClose()
    };

    if (!isOpen) return null;

    return (
        <div className="dialog-overlay">
            <div className="dialog-content">
                <h3>Terminate Dialysis</h3>
                <div className="input-group-physio">
                    <label>Termination Remarks</label>
                    <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Enter termination remarks..."
                        rows={4}
                        className="input-field"
                    />
                </div>
                <div className="dialog-actions">
                    <button type="button" className="cancel-btn" onClick={onClose}>
                        Cancel
                    </button>
                    <button type="button" className="submit-btn" style={{ cursor: loading ? 'wait' : 'pointer' }} disabled={loading} onClick={handleSubmit}>
                        Confirm Terminate
                    </button>
                </div>
            </div>
        </div>
    );
};
export default TerminateDialog;